var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":"请选择一个答案"},on:{"change":function($event){return _vm.$emit('change', $event)}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},_vm._l((_vm.options),function({ label, value }){return _c('el-option',{key:value,attrs:{"label":label,"value":value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }